export default "__VITE_ASSET__BL3OiUgd__"